<template>
  <template v-if="!Util.isEmpty(Warehouses)">
    <DataTable :id="ID" class="table-hover table-lg" :options="Options">
      <thead>
        <tr class="nk-tb-item nk-tb-head">
          <th class="nk-tb-col nk-tb-col-check">
            <div
              class="custom-control custom-control-sm custom-checkbox notext"
            >
              <input type="checkbox" class="custom-control-input" id="uid" />
              <label class="custom-control-label" for="uid"></label>
            </div>
          </th>
          <th class="nk-tb-col" style="min-width: 200px">Warehouse name</th>
          <!-- <th class="nk-tb-col tb-col-mb">Payables</th> -->
          <th class="nk-tb-col tb-col-lg">Telephone</th>
          <th class="nk-tb-col tb-col-md">Email</th>
          <th class="nk-tb-col nk-tb-col-tools text-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="nk-tb-item"
          v-for="warehouse in Warehouses"
          :key="warehouse.uuid"
        >
          <td class="nk-tb-col nk-tb-col-check">
            <div
              class="custom-control custom-control-sm custom-checkbox notext"
            >
              <input type="checkbox" class="custom-control-input" id="uid1" />
              <label class="custom-control-label" for="uid1"></label>
            </div>
          </td>
          <td class="nk-tb-col">
            <router-link
              :to="{
                name: 'warehouse-detail',
                params: { uuid: warehouse.uuid },
              }"
              class="cursor"
            >
              <div class="size15 nowrap ellipsis">
                {{ warehouse.warehouse_name + " " }}
              </div>
              <div
                v-if="warehouse.fullname"
                class="size12 w3-text-grey ellipsis"
              >
                <span class="d-none"> (</span>
                {{ warehouse.fullname }}
                <span class="d-none">)</span>
              </div>
            </router-link>
          </td>
          <!-- <td class="nk-tb-col tb-col-md" v-html="Util.Currency('0.00')"></td> -->
          <td class="nk-tb-col tb-col-lg ellipsis">
            <a
              v-if="warehouse.telephone"
              :href="'tel:' + warehouse.email"
              target="_blank"
              class="d-block"
              >{{ warehouse.telephone }}
            </a>
          </td>
          <td class="nk-tb-col tb-col-md ellipsis">
            <a
              v-if="warehouse.email"
              :href="'mailto:' + warehouse.email"
              target="_blank"
              >{{ warehouse.email }}
            </a>
          </td>
          <td class="nk-tb-col nk-tb-col-tools">
            <ul class="nk-tb-actions gx-1">
              <li>
                <div class="drodown">
                  <a
                    href="#"
                    class="dropdown-toggle btn btn-icon btn-trigger"
                    data-toggle="dropdown"
                    ><em class="icon ni ni-more-h"></em>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <ul class="link-list-opt no-bdr">
                      <!-- <li>
                        <a
                          title="Create New Bill"
                          :data-uuid="warehouse.uuid"
                          href="#"
                        >
                          <em class="icon ni ni-file"></em>
                          <span>New Bill</span></a
                        >
                      </li>
                      <li>
                        <a
                          title="Create New Purchase Order"
                          :data-uuid="warehouse.uuid"
                          href="#"
                        >
                          <em class="icon fas fa-file-alt"></em>
                          <span>New Purchase Order</span></a
                        >
                      </li>

                      <li class="divider"></li> -->
                      <li>
                        <a
                          title="Email Warehouse"
                          :data-uuid="warehouse.uuid"
                          @click.prevent="DeleteDetail(warehouse.uuid)"
                          href="#"
                        >
                          <em class="icon ni ni-mail-fill"></em>
                          <span>Email Warehouse</span></a
                        >
                      </li>
                      <li>
                        <router-link
                          title="Warehouse Detail"
                          :to="{
                            name: 'warehouse-detail',
                            params: { uuid: warehouse.uuid },
                          }"
                          class="cursor"
                        >
                          <em class="icon ni ni-eye"></em>
                          <span>Warehouse Detail</span></router-link
                        >
                      </li>
                      <li>
                        <a
                          title="Edit"
                          :data-uuid="warehouse.uuid"
                          @click.prevent="QuickEdit(warehouse.uuid)"
                          href="#"
                        >
                          <em class="icon fas fa-edit"></em>
                          <span>Edit Warehouse</span></a
                        >
                      </li>
                      <li>
                        <a
                          title="Edit"
                          :data-uuid="warehouse.uuid"
                          @click.prevent="DeleteDetail(warehouse.uuid)"
                          href="#"
                        >
                          <em class="icon fas fa-trash"></em>
                          <span>Delete Warehouse</span></a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </DataTable>
  </template>
  <div v-else class="p-5 w3-center">
    <img src="/images/item-not-found.png" class="mb-4" />
    <h4>No Item was found</h4>
    <a
      href="#"
      title="Add new warehouse"
      class="btn btn-white btn-dim btn-outline-light"
      @click.prevent="addWarehouse = true"
    >
      <em class="icon ni ni-edit"></em>
      <span class="d-none d-md-inline">Add a new warehouse</span>
    </a>
  </div>
  <AddWarehouse
    :toggle-by="addWarehouse"
    @oncancel="addWarehouse = false"
    @onsave="addWarehouse = false"
    title="Add a new warehouse"
  ></AddWarehouse>
  <Aside
    :toggle-by="DoEdit"
    @oncancel="OnCancel"
    cancel-text="Cancel"
    width="1024px"
  >
    <WarehouseUpdate
      tabbed
      v-if="DoEdit"
      :warehouse="Warehouse"
      @onsave="OnSave"
      @oncancel="OnCancel"
    />
  </Aside>
</template>
<script>
import {
  // computed,
  ref,
  toRef,
} from "vue";
import { useStore } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { Util } from "@/helpers/utilities";
import DataTable from "@/components/ui/DataTable.vue";
import WarehouseUpdate from "@/components/ui/warehouse/WarehouseUpdate.vue";
import AddWarehouse from "@/components/ui/warehouse/AddWarehouse.vue";
import Aside from "@/components/ui/Aside.vue";
export default {
  components: {
    DataTable,
    AddWarehouse,
    WarehouseUpdate,
    Aside,
  },
  props: {
    id: {
      type: String,
    },
    warehouses: {
      type: Array,
    },
  },

  setup(props) {
    const store = useStore();
    const ID = props.id ? props.id : uuidv4();
    const Warehouses = toRef(props, "warehouses");
    const addWarehouse = ref(false);
    const Options = {
      pageLength: 25,
      responsive: false,
      order: [[0, "asc"]],
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: [0],
        },
      ],
    };

    const DeleteDetail = (uuid) => {
      console.log("DeleteDetail", uuid);
    };
    const Warehouse = ref({});
    const DoEdit = ref(false);
    const QuickEdit = async (uuid) => {
      const _warehouse = await store.dispatch("warehouses/getWarehouse", uuid);
      Warehouse.value = {
        ..._warehouse,
      };
      DoEdit.value = true;
    };
    const OnCancel = () => {
      Warehouse.value = {};
      DoEdit.value = false;
    };
    const OnSave = () => {
      OnCancel();
    };
    return {
      store,
      ID,
      Warehouse,
      Warehouses,
      addWarehouse,
      QuickEdit,
      Util,
      Options,
      OnSave,
      DeleteDetail,
      DoEdit,
      OnCancel,
    };
  },
};
</script>